import { translate } from '../../common/helpers/translate.helper';
import { useOpenFreshchat } from '../../common/hooks/useOpenFreshchat';
import { InteractiveTranslation } from '../../common/InteractiveTranslation';

export const ApiKeyDescription = () => {
    const openFreshchat = useOpenFreshchat();

    return <InteractiveTranslation translation={translate('apikey.description')} onClick={openFreshchat} />;
};
